<template>
<div>
  <div id="menuNagusia" class="ui top fixed menu">
    <a class="item" v-on:click="showMenu()"><i class="bars icon"></i></a>
    <div class="right menu" v-on:click="goTo('/users/profile','profile')">
      <a id='profile' class="item">
        <img class="ui avatar image" src="../assets/user.png">
        <span>{{username}}</span>
      </a>
      <a class="item" v-on:click="logout()">Logout</a>
    </div>
  </div>
  <div id="bigarrenMenua" class="ui left fixed vertical menu">
    <div class="item logoItem">
      <i id='menuaItxi' class="close icon" v-on:click="hideMenu()"></i>
      <img v-if="companyImage" class="ui small centered image" :src="this.companyImage">
      <img v-if="!companyImage" class="ui small centered image" src="../assets/name.png">
    </div>
    <a id='home' class="item" v-if="(this.role === 'master' || this.role === 'admin')" v-on:click="goTo('/dashboard','home')">Home</a>
<!--     <a id='parcels' class="item" v-if="!(this.role.includes('apiclient')) && this.role!='shophapiickPoint' && this.role!='clientApi' && this.role!='courier' && this.role!='master' && this.role!='admin' && this.role!='sabico' && this.role!='cau' && !this.role.includes('inbox') && !this.role.includes('local') && this.role!='hmyCorporate'" v-on:click="goTo('/parcels', 'parcels')">Paquetes</a>
    <a id='parcels_v2' class="item" v-if="((this.role.includes('apiclient')) || this.role === 'clientApi' || this.role === 'master' || this.role === 'admin' || this.role === 'courier')" v-on:click="goTo('/parcels_v2', 'parcels_this.role!='sabico' && this.role!='cau'v2')">Paquetes</a> -->
    <a id='parcels_v2' class="item" v-if="(this.role!='sabico' && this.role!='cau' && !this.role.includes('local') && !this.role.includes('inbox') )" v-on:click="goTo('/parcels_v2', 'parcels_v2')">Paquetes</a>
    <a id='shparcellist' class="item" v-if="(this.role === 'shophapiickPoint')" v-on:click="goTo('/history','history')">Pedidos</a>
    <a id='localParcels' class="item" v-if="(this.role === 'localUser' || this.role === 'localAdmin')" v-on:click="goTo('/local/parcels', 'localParcels')">Paquetes</a>
    <a id='generateParcel' class="item" v-if="this.ext === 'nacex'" v-on:click="goTo('/generateParcel','generateParcel')">Generar Envíos</a>
    <a id='receivedReport' class="item" v-if="(this.role.includes('apiclient') || this.role.includes('staffappmediamarkt') || this.role === 'clientApi')" v-on:click="goTo('/receivedReport','receivedReport')">Informe Recibidos</a>
    <a id='stats' class="item" v-if="this.role!='shophapiickPoint' && this.role!='sabico' && this.role!='cau' && !this.role.includes('inbox') && this.role!='localUser' && this.role!='hmyCorporate'" v-on:click="goTo('/stats','stats')">Estadísticas</a>
    <a id='apms' class="item" v-if="this.role!='sabico' && this.role!='cau' && this.role!='inboxUser' && this.role!='inboxAdmin' && this.role!='hmyCorporate' && this.role!='localUser'" v-on:click="goTo('/apms','apms')">Listado APMs</a>
    <a id='corporationUsers' class="item" v-if="(this.role==='corporate')" v-on:click="goTo('/corporations/users','corporationUsers')">Usuarios</a>
    <a id='corporations' class="item" v-if="(this.role==='master'||this.role==='admin'||this.role==='hmyCorporate')" v-on:click="goTo('/corporations','corporations')">Corporaciones</a>
    <a id='locals' class="item" v-if="(this.role === 'master' || this.role === 'admin')" v-on:click="goTo('/local','locals')">Locals</a>
    <!-- <a id='inbox' class="item" v-if="(this.role === 'master' || this.role === 'admin')" v-on:click="goTo('/inbox','inbox')">Inbox</a> -->
    <a id='users' class="item" v-if="this.role==='master'" v-on:click="goTo('/users','users')">Usuarios</a>
    <a id='companies' class="item" v-if="(this.role==='master'||this.role==='admin')" v-on:click="goTo('/companies','companies')">Compañías</a>
    <a id='troubleshooting' class="item" v-if="this.role==='master'||this.role==='admin'||this.role==='sabico' || this.role==='cau'" v-on:click="goTo('/troubleshooting','troubleshooting')">Incidencias</a>
    <a id='inboxParcels' class="item" v-if="(this.role === 'inboxUser' || this.role === 'inboxAdmin')" v-on:click="goTo('/inbox/parcels', 'parcels')">Paquetes</a>
    <a id='generateInboxParcel' class="item" v-if="(this.role === 'inboxUser')" v-on:click="goTo('/inbox/generateParcel','generateInboxParcel')">Generar Envíos</a>
    <a id='inboxUsers' class="item" v-if="(this.role === 'inboxAdmin')" v-on:click="goTo('/inbox/users','inboxUsers')">Usuarios</a>
    <a id='generateLocalParcel' class="item" v-if="(this.role === 'localUser' || this.role === 'localAdmin')" v-on:click="goTo('/local/generateParcel','generateLocalParcel')">Generar Envíos</a>
    <a id='localUsers' class="item" v-if="(this.role === 'localAdmin')" v-on:click="goTo('/local/users','localUsers')">Usuarios</a>
    <a id='generateAllClientParcel' class="item" v-if="(this.role === 'master')" v-on:click="goTo('/generateAllClientParcel','generateAllClientParcel')">Generar Envío</a>
    <a id='billing' class="item" v-if="(this.role === 'master' || this.role === 'admin')" v-on:click="goTo('/billing','billing')">Facturación</a>
    <a id='inventory' class="item" v-if="(this.role === 'master' || this.role === 'admin')" v-on:click="goTo('/inventory','inventory')">Inventario y Actuaciones</a>
    <p class="item"></p>
    <div v-if="baseLogo === 'logoHH.png'" class="footer">
      <img class="ui small centered image" src="../assets/logoHH.png">
    </div>
    <div v-else  class="footer">
      <img class="ui mini centered image" src="../assets/logo.png">
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi, setToken } from '@/api/hapiickApi';
export default {
  name: 'Navbar',
  data() {
    return {
      userImage: null,
      companyImage: null,
      baseLogo: null,
      role: null,
      username: null,
      id: null,
      windowWidth: 0,
      ext: null
    }
  },
  created() {
    this.userImage = JSON.parse(localStorage.admin).image_url
    this.ext = JSON.parse(localStorage.company).ext
    this.companyImage = JSON.parse(localStorage.company).image_url
    this.baseLogo = JSON.parse(localStorage.theme).base_logo
    this.role = JSON.parse(localStorage.admin).role
    this.username = JSON.parse(localStorage.admin).username
    this.id = JSON.parse(localStorage.admin).id
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
      //Init
      this.getWindowWidth()
    })

  },
  methods: {
    logout() {
      hapiickApi().post('/v1/logout', {
        admin_id: this.id,
      })
      .then(request => {
        this.exit()
      })
      .catch(() => this.exit())
    },
    exit() {
      this.$router.replace('/')
      localStorage.clear()
      setToken(null)
    },
    goTo(where, id) {
      if (window.innerWidth < 600) {
        this.hideMenu()
      }
      let elems = document.getElementsByClassName('item')
      for (var i = 0; i < elems.length; i++) {
        elems[i].classList.remove('active');
      }
      this.$router.push(where)
      document.getElementById(id).classList.add("active")
    },
    showMenu() {
      document.getElementById('bigarrenMenua').style.visibility = "visible"
    },
    hideMenu() {
      document.getElementById('bigarrenMenua').style.visibility = "hidden"
    },
    getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth
      if (this.windowWidth < 600) {
        this.hideMenu()
      } else {
        this.showMenu()
      }
    }
  }
}
</script>

<style scoped>
#menuaItxi {
  display: none;
  margin-left: 10rem;
  margin-bottom: 3vh;
  cursor: pointer;
}
.logoItem {
  margin-top: 10vh;
  margin-bottom: 1vh;
}
.footer {
  /* bottom: 1vh;
   left:60px; 
  position: fixed; */
  position: absolute;
  bottom: 1vh;
  width: 100%;
  /* height: 2vh;  */
}
.vertical {
  text-align: center;
  color: black !important;
  background-color: var(--var-color) !important;
}
.item {
  font-size: 16px !important;
  font-weight: bold !important;
}
.perfil {
  font-size: 14px !important;
  font-weight: normal !important;
}
.footerTextLogo{
  font-size: 11px;
  font-weight:bolder;
  color: black;
}
@media only screen and (max-width: 600px) {
  .logoItem {
    margin-top: 1vh;
    margin-bottom: 1vh;
  }
  #bigarrenMenua {
    visibility: hidden;
  }
  #menuaItxi {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue